import { Link, useLocation } from "react-router-dom";

export default function LegalSidebar() {
    const { pathname } = useLocation();

    const linkClass = (path) =>
        `block px-4 py-2 rounded ${pathname.startsWith(path)
            ? "bg-indigo-600 text-white"
            : "text-gray-700 hover:bg-gray-200"
        }`;

    return (
        <div className="w-64 bg-gray-100 p-4 min-h-screen">
            <h2 className="text-xl font-bold mb-4">Legal Panel</h2>

            <nav className="space-y-2">
                <Link to="/legal/profile" className={linkClass("/legal/profile")}>
                    Profile
                </Link>

                <Link to="/legal/orders" className={linkClass("/legal/orders")}>
                    Orders
                </Link>

                <Link to="/legal/orders/create" className={linkClass("/legal/orders/create")}>
                    Create Order
                </Link>

                <Link to="/legal/shipments" className={linkClass("/legal/shipments")}>
                    Shipments
                </Link>
            </nav>
        </div>
    );
}